import { render, staticRenderFns } from "./GiveCoupon.vue?vue&type=template&id=24f5c02f&"
import script from "./GiveCoupon.vue?vue&type=script&lang=ts&"
export * from "./GiveCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports